import React, { useEffect, useState } from "react";

import { Bar } from "react-chartjs-2";

import { FormControl, MenuItem, Select, makeStyles } from "@material-ui/core";

import { numberToCurrency } from "@ip-utils";
import { monthlyBalancesFromLedgers } from "@ip-utils/chart";
import { Card } from "@ip-widgets";

const useStyles = makeStyles((theme) => ({
  chart: {
    position: "relative",
    height: "300px",
  },
}));

export default function FundsTimeline({ ledgers, loading }) {
  const classes = useStyles();

  const [currency, setCurrency] = useState("THB");
  const [data, setData] = useState({});
  const [maxValue, setMaxValue] = useState(100);

  useEffect(() => {
    if (ledgers === undefined || ledgers.length === 0) return;

    const chartData = monthlyBalancesFromLedgers(ledgers, currency);

    setMaxValue(chartData.maxValue);

    setData({
      labels: chartData.months,
      datasets: [
        {
          label: "Credit",
          backgroundColor: "#0a73e0",
          data: chartData.creditBalances,
        },
        {
          label: "Debit",
          backgroundColor: "#021033",
          data: chartData.debitBalances,
        },
      ],
    });
  }, [ledgers, currency]);

  const handleChange = (event) => {
    setMaxValue(100);
    setCurrency(event.target.value);
  };

  const chartOptions = {
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            color: "rgba(246,246,246,1)",
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            min: -maxValue,
            max: maxValue,
            callback: function (value, index, values) {
              if (index === values.length - 1)
                return numberToCurrency(-maxValue);
              else if (index === 0) return numberToCurrency(maxValue);
              else return "";
            },
          },
          gridLines: {
            color: "rgba(246,246,246,1)",
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || "";
          if (label) {
            label += ": ";
          }
          label += numberToCurrency(tooltipItem.yLabel);
          return label;
        },
      },
    },
  };

  return (
    <Card collapsable title="Funds Timeline">
      <Card.Toolbar>
        <FormControl className={classes.formControl}>
          <Select
            labelId="currency-select-label"
            id="currency-select"
            value={currency}
            onChange={handleChange}
          >
            <MenuItem value={"THB"}>THB</MenuItem>
            <MenuItem value={"EUR"}>EUR</MenuItem>
            <MenuItem value={"USD"}>USD</MenuItem>
            <MenuItem value={"HKD"}>HKD</MenuItem>
            <MenuItem value={"VND"}>VND</MenuItem>
          </Select>
        </FormControl>
      </Card.Toolbar>
      <Card.Body loading={loading}>
        <div className={classes.chart}>
          {Object.keys(data).length !== 0 ? (
            <Bar data={data} height={300} options={chartOptions} />
          ) : null}
        </div>
      </Card.Body>
    </Card>
  );
}
